import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  LoadEstimationTargetSampleColumns,
  LoadEstimationTargetSampleCountSuccess,
  LoadEstimationTargetSampleSuccess,
  PagingChanged,
} from '../actions/estimation-target-sample.actions';

export interface EstimationTargetSampleState extends EntityState<any> {
  columns: { [label: string]: string };
  totalResults: number;
  itemsNumber: number;
  paginator: {
    previousPageIndex: number;
    pageIndex: number;
    pageSize: number;
    length: number;
  };
}

export const estimationTargetSampleAdapter = createEntityAdapter<any>();

const initialState: EstimationTargetSampleState = estimationTargetSampleAdapter.getInitialState({
  columns: {},
  totalResults: 0,
  itemsNumber: 10,
  paginator: {
    previousPageIndex: 0,
    pageIndex: 0,
    pageSize: 0,
    length: 0,
  },
});

export const EstimationTargetSampleReducer = createReducer(
  initialState,
  on(LoadEstimationTargetSampleColumns, (state, { columns }) => ({
    ...state,
    columns,
  })),
  on(LoadEstimationTargetSampleCountSuccess, (state, { count }) => ({
    ...state,
    totalResults: count,
  })),
  on(PagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(LoadEstimationTargetSampleSuccess, (state, { data }) => {
    const estimationTargetSampleData = data.map((item: any) => ({
      id: item.id,
      firstName: item.firstName,
      lastName: item.lastName,
      loyaltyCard: item.loyaltyCard,
      points: item.points,
      schema: item.schemaId,
      email: item.email,
      mobile: item.mobile,
      smsOptOut: item.smsOptOut,
      emailOptOut: item.emailOptOut,
      // set data here
    }));
    return estimationTargetSampleAdapter.setAll(estimationTargetSampleData, { ...state });
  }),
);
